/**
 * @desc 产品BOM-修改并提交工作流
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductBomResponseDto>;
export function request(body: defs.basics.ProductBomRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/updateAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
